export enum AdministrationRole {
  UAKDO_ADMINISTRATOR = 'UAKDO_ADMINISTRATOR',
  UAKDO_CONTROLLER = 'UAKDO_CONTROLLER',
  USAPOK_ADMINISTRATOR = 'USAPOK_ADMINISTRATOR',
  USAPOK_CONTROLLER = 'USAPOK_CONTROLLER',
  UBTF_ADMINISTRATOR = 'UBTF_ADMINISTRATOR',
  UBTF_CONTROLLER = 'UBTF_CONTROLLER',
  MANAGER = 'MANAGER',
  MANAGER_CONTROLLER = 'MANAGER_CONTROLLER',
  PM_MANAGER = 'PM_MANAGER',
  AM_MANAGER = 'AM_MANAGER',
  ASSET_MANAGER = 'ASSET_MANAGER',
  UO_ADMINISTRATOR = 'UO_ADMINISTRATOR',
  UO_CONTROLLER = 'UO_CONTROLLER',
  UMVN_ADMINISTRATOR = 'UMVN_ADMINISTRATOR',
  UMVN_CONTROLLER = 'UMVN_CONTROLLER',
  BUSINESS_MANAGER = 'BUSINESS_MANAGER',
  COVENANTS_BRANCH_MANAGER = 'COVENANTS_BRANCH_MANAGER',
  CALL_CENTER_OPERATOR = 'CALL_CENTER_OPERATOR',
  PERSONAL_DATA_MANAGER = 'PERSONAL_DATA_MANAGER',
  OBSERVER = 'OBSERVER',
}

export enum TaskFetchStatus {
  Idle = 'idle',
  Loading = 'loading',
  Success = 'success',
  Error = 'error',
}

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc',
  None = 'none',
}

export enum GuaranteesApplicationStatus {
  DRAFT = 'DRAFT',
  AWAITING_CLIENT_INITIAL_SIGN = 'AWAITING_CLIENT_INITIAL_SIGN',
  IN_PROGRESS_CLIENT_INITIAL_SIGN = 'IN_PROGRESS_CLIENT_INITIAL_SIGN',
  AWAITING_AM_APPROVAL_LETTER = 'AWAITING_AM_APPROVAL_LETTER',
  IN_PROGRESS_AM_APPROVAL_LETTER = 'IN_PROGRESS_AM_APPROVAL_LETTER',
  AWAITING_PM_MANAGER_TERMS = 'AWAITING_PM_MANAGER_TERMS',
  IN_PROGRESS_PM_MANAGER_TERMS = 'IN_PROGRESS_PM_MANAGER_TERMS',
  AWAITING_UDBTF_ISSUANCE_TERMS = 'AWAITING_UDBTF_ISSUANCE_TERMS',
  IN_PROGRESS_UDBTF_ISSUANCE_TERMS = 'IN_PROGRESS_UDBTF_ISSUANCE_TERMS',
  AWAITING_INTERNAL_APPROVALS = 'AWAITING_INTERNAL_APPROVALS',
  IN_PROGRESS_INTERNAL_APPROVALS = 'IN_PROGRESS_INTERNAL_APPROVALS',
  AWAITING_CLIENT_APPROVAL_LETTER_SIGN = 'AWAITING_CLIENT_APPROVAL_LETTER_SIGN',
  IN_PROGRESS_CLIENT_APPROVAL_LETTER_SIGN = 'IN_PROGRESS_CLIENT_APPROVAL_LETTER_SIGN',
  AWAITING_AM_APPROVAL_LETTER_SENT_MANUAL_SIGN = 'AWAITING_AM_APPROVAL_LETTER_SENT_MANUAL_SIGN',
  IN_PROGRESS_AM_APPROVAL_LETTER_SENT_MANUAL_SIGN = 'IN_PROGRESS_AM_APPROVAL_LETTER_SENT_MANUAL_SIGN',
  AWAITING_UAKDO_APPROVAL = 'AWAITING_UAKDO_APPROVAL',
  IN_PROGRESS_UAKDO_APPROVAL = 'IN_PROGRESS_UAKDO_APPROVAL',
  AWAITING_UAKDO_CONTROLLER_APPROVAL = 'AWAITING_UAKDO_CONTROLLER_APPROVAL',
  IN_PROGRESS_UAKDO_CONTROLLER_APPROVAL = 'IN_PROGRESS_UAKDO_CONTROLLER_APPROVAL',
  AWAITING_UDBTF_APPROVAL = 'AWAITING_UDBTF_APPROVAL',
  IN_PROGRESS_UDBTF_APPROVAL = 'IN_PROGRESS_UDBTF_APPROVAL',
  AWAITING_GUARANTEE_ISSUANCE = 'AWAITING_GUARANTEE_ISSUANCE',
  IN_PROGRESS_GUARANTEE_ISSUANCE = 'IN_PROGRESS_GUARANTEE_ISSUANCE',
  AWAITING_USAPOK_APPROVAL = 'AWAITING_USAPOK_APPROVAL',
  IN_PROGRESS_USAPOK_APPROVAL = 'IN_PROGRESS_USAPOK_APPROVAL',
  AWAITING_USAPOK_CONTROLLER_APPROVAL = 'AWAITING_USAPOK_CONTROLLER_APPROVAL',
  IN_PROGRESS_USAPOK_CONTROLLER_APPROVAL = 'IN_PROGRESS_USAPOK_CONTROLLER_APPROVAL',
  ISSUED = 'ISSUED',
  COMPLETED = 'COMPLETED',
  REJECTED = 'REJECTED',
}

export enum GuaranteesApprovalStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  APPROVED = 'APPROVED',
  SKIPPED = 'SKIPPED',
  DENIED = 'DENIED',
}

export type TTasksAssigneeUnit = 'DEFAULT' | 'UDBTF' | 'UMVN' | 'UO';

export type TTaskApplication = Record<string, unknown> & {
  id: string;
  applicationId?: string;
  contragentId?: string;
  version?: number;
  applicationStatus?: string;
  applicationNumber?: string;
  createdAt?: string;
  managerId?: string;
  managerEmail?: string;
  principal?: Record<string, unknown> & {
    shortName?: string;
    fullName?: string;
    identifyCode?: string;
  };
  root?: Record<string, unknown> & { applicationNumber?: string; applicationDate?: string };
  executionCheck?: string | null;
  executionChecks?: Record<string, unknown>;
  processingDeadline?: string | null;
  processingOverdue?: boolean | null;
  udbtfProcessingDeadline?: string | null;
  udbtfProcessingOverdue?: boolean | null;
  umvnProcessingDeadline?: string | null;
  umvnProcessingOverdue?: boolean | null;
  uoProcessingDeadline?: string | null;
  uoProcessingOverdue?: boolean | null;
  udbtfApprovalStatus?: string | null;
  uoApprovalStatus?: string | null;
  umvnApprovalStatus?: string | null;
  assignedEmployeeEmail?: string | null;
  udbtfAssignedEmployeeEmail?: string | null;
  umvnAssignedEmployeeEmail?: string | null;
  uoAssignedEmployeeEmail?: string | null;
  inProgressEmployeeEmail?: string | null;
  udbtfInProgressEmployeeEmail?: string | null;
  umvnInProgressEmployeeEmail?: string | null;
  uoInProgressEmployeeEmail?: string | null;
};

export const normalizeTaskApplicationStatus = (
  status?: string | null
): GuaranteesApplicationStatus =>
  Object.values(GuaranteesApplicationStatus).includes(status as GuaranteesApplicationStatus)
    ? (status as GuaranteesApplicationStatus)
    : GuaranteesApplicationStatus.DRAFT;
